import React from 'react'

import { Stack } from '@zet/design-system'
import { Control, Controller, FieldValues } from 'react-hook-form'

import { IOcField, IOcFieldError } from '../utils/types'
import FormComponent from './FormComponent'

interface Props {
  control: Control<FieldValues, any>
  ocFieldError?: IOcFieldError
  ocField: IOcField
}

const FormController: React.FC<Props> = (props) => {
  const { control, ocFieldError, ocField } = props

  return (
    <Controller
      control={control}
      name={String(ocField?.name ?? '')}
      render={(formControllerRenderProps) => {
        return (
          <Stack className="mb-4">
            <FormComponent
              formControllerRenderProps={formControllerRenderProps}
              formValidationError={formControllerRenderProps.fieldState.error}
              ocFieldError={ocFieldError}
              ocField={ocField}
            />
          </Stack>
        )
      }}
    />
  )
}

export default FormController
